import React, { useEffect } from "react";
import loading from "../../assets/loading.gif";
import MainpageHook from "../../pages/HomePage/hooks/MainpageHook";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const Loading = () => {
  const { ...param } = MainpageHook();
  const updatedRoute = useSelector((state) => state.GlobalReducer.newRoute);
  console.log(updatedRoute);
  const navigate = useNavigate();
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      navigate(updatedRoute, { replace: true });
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, [navigate, updatedRoute]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        backgroundColor: "white",
        position: "absolute",
        top: 0,
        left: 0,
      }}
    >
      <img
        src={loading}
        alt="Logo"
        style={{ width: "100px", height: "100px" }}
      />
    </div>
  );
};

export default Loading;
